import React from 'react';
import { useController, type Control, type FieldValues, type FieldPath } from 'react-hook-form';
import { CryptoSelect } from '../atoms/CryptoSelect';

/**
 * React Hook Form wrapper for CryptoSelect component
 * Integrates CryptoSelect with React Hook Form's control system
 */
interface CryptoSelectFieldProps<T extends FieldValues> {
  name: FieldPath<T>;
  control: Control<T>;
  label?: string;
  placeholder?: string;
  required?: boolean;
  className?: string;
}

export const CryptoSelectField = <T extends FieldValues>({
  name,
  control,
  label,
  placeholder,
  required = false,
  className = '',
}: CryptoSelectFieldProps<T>) => {
  const { field, fieldState } = useController({
    name,
    control,
  });

  return (
    <div className={className}>
      {label && (
        <label htmlFor={name} className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}
      <CryptoSelect
        value={field.value}
        onChange={field.onChange}
        placeholder={placeholder}
        required={required}
      />
      {fieldState.error && (
        <span className="text-sm text-red-600 mt-1 block">
          {fieldState.error.message}
        </span>
      )}
    </div>
  );
};
